import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from 'uuid';

export default function InputText({
    handleCancel,
    handleSave,
    label,
    name,
    type,
    value
}) {
    const [val, set_val] = useState(value);
    const input = useRef(null);
    const id = useRef(`${name}-${uuidv4()}`);

    useEffect(() => {
        input.current.focus();
    }, []);

    function handle_change(e) {
        set_val(e.target.value);
    }

    return (
        <>
        <form className="form-inline">
            <div className="form-group">
                <div className="input-group-prepend">
                    <label htmlFor={id.current} className="form-label text-capitalize mr-2 pl-2">{label}:</label>
                </div>
                <div className="input-group">
                    <input
                        className="border-0"
                        id={id.current}
                        onChange={e => handle_change(e)}
                        ref={input}
                        type={type} 
                        value={val}/>
                    <div className="input-group-append">
                        <button 
                            className="btn btn-link"
                            onClick={() => handleSave(val)}
                        >
                            Update
                        </button>
                        <button 
                            className="btn btn-link"
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </form>
        </>
    );
}

InputText.propTypes = {
    handleCancel: PropTypes.func.isRequired,
    handleSave: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
}

InputText.defaultProps = {
    handleCancel: () => false,
    handleSave: () => false,
    label: "Text Input",
    name: "input_text",
    type: "text",
    value: "",
}